<template>
    <div>
        <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
            <template slot="title">Templates</template>
        </page-header>
        <pro-table
            :resource="resource"
            prefix="/configuration/"
            :fields="fields"
            :filters="filters"
            :filters-loading="filtersLoading"
            :limit="25"
            ref="datatable"
            class="px-6 pt-2"
            @action="actionHandler"
            sort="name"
            direction="ASC"
            delete-label="name"
            :actions="actions"
            :permissions="true"
        ></pro-table>
    </div>
</template>

<script>
    import DataTableSetup from '../../../mixins/DataTableSetup';

    export default {
        name: "Templates",
        mixins: [ DataTableSetup ],
        data: function() {
            return {
                resource: 'templates',
                numberOfFilters: 2,
                pageActions: {},
                fields: [
                    {
                        name: 'Name',
                        column: 'name',
                    },
                    {
                        name: 'Type',
                        column: 'type.name'
                    },
                    {
                        name: 'Active',
                        column: 'active',
                        boolean: true,
                        toggle: true,
                        align: 'center'
                    }
                ],
                actions: {
                    display: true,
                    class: [],
                    options: [
                        { label: 'Edit', link: 'edit', icon: 'edit', type: 'router-link', tooltip: 'Edit', permissions: 'templates.edit' },
                        { label: 'Delete', method: 'delete', icon: 'trash-alt', type: 'method', tooltip: 'Delete', permissions: 'templates.destroy' },
                    ]
                }
            }
        },
        methods: {
            methodHandler: function(method){
                this[method]();
            },
        },
        mounted() {
            //Search Filter
            const searchFilter = {
                label: 'Search',
                name: 'search',
                type: 'text',
                width: 'w-1/4',
                value: this.searchValue,
                placeholder: 'Search...'
            };

            this.filters.push(searchFilter);

            // Groups Filter
            const typesFilter = {
                label: 'Type',
                name: 'type',
                type: 'select',
                options: this.$store.getters.templateTypes.map(function (type) {
                    return {label: type.name, value: type.id};
                }),
                width: 'w-1/4',
                value: this.typeValue,
                placeholder: 'Select Type...'
            };

            if (this.$store.getters.templateTypes.length === 0){
                this.$store.dispatch('GET_TEMPLATE_TYPES').then(() => {
                    typesFilter.options = this.$store.getters.templateTypes.map(function (type) {
                        return { label: type.name, value: type.id };
                    });
                    typesFilter.value = this.typeValue;
                    this.filters.push(typesFilter);
                    this.$Progress.finish();
                });
            } else {
                this.filters.push(typesFilter);
            }

            this.pageActions = {
                buttons: [
                    {
                        label: 'New Template',
                        icon: 'plus',
                        type: 'router-link',
                        link: '/configuration/templates/create',
                        iconClass: 'text-green-600',
                        display: this.$store.getters.permissions.indexOf('templates.create') !== -1
                    }
                ],
                additional: []
            }
        },
        computed: {
            typeValue(){
                const filters = this.$store.getters.filters;

                if (!window._.isEmpty(filters.templates.type)){
                    return filters.templates.type;
                } else {
                    return null;
                }
            },
            searchValue () {
                const filters = this.$store.getters.filters;

                if (filters.templates.search){
                    return filters.templates.search.value;
                } else {
                    return '';
                }
            }
        }
    }
</script>

<style scoped>

</style>
